import { nodeAttributeLabel } from "~/node";
import { costTypeOptions } from "./constants";

export const costTypeLabel = nodeAttributeLabel(costTypeOptions);
